import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { map, switchMap, catchError } from 'rxjs/operators';
import {
  VALIDATE_AUDIENCE_CSV_FILE,
  VALIDATE_AUDIENCE_CSV_FILE_SUCCESS
} from '../../constants';

import { toast } from 'react-toastify';

let toastId = 'validateCsv';


const validateAudienceCSV = (action$, state$) =>
  action$.pipe(
    ofType(VALIDATE_AUDIENCE_CSV_FILE),
    switchMap(action => {

      var formData = new FormData();
      formData.append("audienceSummaryCSV", action.file[0]);

      toastId = toast('Validating CSV File...', {
        id: toastId,
        autoClose: false,
        position: 'top-center',
        style: { textAlign: 'center' },
        closeButton: false, // Remove the closeButton
      });

      return ajax({
        url:  `${state$.value.auth.server}/campaign/validate?type=audienceSummary`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        body: formData,
        crossDomain: true,
        method: 'POST',
      }).pipe(
        map(response => {

          toast.update(toastId, {
            id: toastId,
            type: toast.TYPE.INFO,
            render: "Validate Completed",
            autoClose: 3000,
            hideProgressBar: true,
            progress: undefined,
            style: { backgroundColor: 'rgb(237, 247, 237)', color: 'rgb(30, 70, 32)', textAlign: 'center' },
            closeButton: null // The closeButton defined on ToastContainer will be used
          });

          return {
            type: VALIDATE_AUDIENCE_CSV_FILE_SUCCESS,
            data: response.response
          };
        }),
        catchError(error => {
          console.log(error);
          toast.update(toastId, {
            id: toastId,
            type: toast.TYPE.INFO,
            render: error.response.message,
            autoClose: 6000,
            hideProgressBar: true,
            progress: undefined,
            style: { backgroundColor: 'rgb(253, 236, 234)', color: 'rgb(97, 26, 21)', textAlign: 'center' },
            closeButton: null // The closeButton defined on ToastContainer will be used
          });
        })
      );
    })
  );

export default validateAudienceCSV;
